import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'

import Auth from '../routes/auth-mobile'
import Layout from '../components/layout/layout-mobile'
import Main from '../routes/main-mobile'
import Zakaz from '../routes/zakaz-mobile'


function Mobile({ authState }) {
  const isZakazHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'erpmarklizakaz.slamdev.ru' ||
      window.location.hostname === 'zakaz.markli.by')

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/'>
        {isZakazHost ? (
          <>
            <Route index element={<Zakaz />} />
          </>
        ) : authState.authenticated ? (
          <Route element={<Layout />}>
            <Route index element={<Main />} />
          </Route>
        ) : (
          <Route index element={<Auth />} />
        )}
        <Route path={'zakaz'} element={<Zakaz />} />
      </Route>
    )
  )

  return <RouterProvider router={router} />
}

export default Mobile
